// extracted by mini-css-extract-plugin
export default {"container":"MapComp_container__TOkkd","paper":"MapComp_paper__THgd9","mapContent":"MapComp_mapContent__UVf79","headers":"MapComp_headers__f4wZ6","label":"MapComp_label__wUvtc"};